import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_ServerAddress } from '../MyAppCommonConfig';
import { CTestSearchModel } from '../models/test.models/testSearchModel.model';
import { CTest } from '../models/test.models/test.model';

@Injectable()
export class TestService {
  constructor(private http: HttpClient) {

  }

  GetList(searchModel: CTestSearchModel) {
    var additionalUrl: string = '?';
    if (searchModel != null) {
      additionalUrl += ('filter=' + JSON.stringify(searchModel))
    }
    // now returns an Observable of CTest[]
    return this.http.get<CTest[]>(API_ServerAddress + 'api/Tests' + additionalUrl);
  }

  Count() {
    return this.http.get<number>(API_ServerAddress + 'api/Tests/Count');
  }

  GetById(id: number) {
    return this.http.get<CTest>(API_ServerAddress + 'api/Tests/' + id);
  }

}